export default {
  label: {
    tooltip: {
      info: 'Component filter',
    },
    icon: {
      key: 'F',
    },
  },
};
